import { render, staticRenderFns } from "./FormationAcademique.vue?vue&type=template&id=5f371fa5"
import script from "./FormationAcademique.vue?vue&type=script&lang=js"
export * from "./FormationAcademique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports